<div
  class="user-menu-trigger flex-row center-center"
  [matTooltip]="'SIDEBAR.USER' | translate"
  matTooltipClass="sidebar-tooltip"
  matTooltipPosition="right"
>
  <app-ui-dropdown #userMenuDropdown [height]="userMenuHeight">
    <div
      class="user-menu-trigger-content flex-row center-center w-100"
      [attr.aria-label]="'SIDEBAR.USER' | translate"
      input
    >
      <span class="user-icon ui-icon-user-sidebar" aria-hidden="true"></span>
    </div>

    <ng-template #contentTemplate>
      <div #userMenu class="user-menu">
        <div class="user-menu-inner flex-col">
          @if (profile(); as user) {
            <div class="menu-title">
              {{ user.firstname }} {{ user.lastname }}
            </div>
            <div class="menu-title">{{ user.email }}</div>
          }
          <hr class="hr" />
          <div
            class="menu-item flex-row start-center"
            (click)="openAccountDetails(); userMenuDropdown.closeDropdown()"
          >
            <div class="flex-row start-center gap-8">
              <span class="icon ui-icon-settings"></span>
              <span>{{ 'SIDEBAR.ACCOUNT_DETAILS' | translate }}</span>
            </div>
          </div>
          <div
            class="menu-item flex-row start-center"
            (click)="logout(); userMenuDropdown.closeDropdown()"
          >
            <div class="flex-row start-center gap-8">
              <span class="icon ui-icon-logout"></span>
              <span>{{ 'CHAT_AUTH.LOGOUT' | translate }}</span>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </app-ui-dropdown>
</div>
